// New service images data structure
export const photoVideographyImages = [
  {
    src: '/images/1.webp',
    alt: 'Photography and Videography',
    description: 'Professional photography and videography services'
  },
  {
    src: '/images/2.webp',
    alt: 'Photo & Video Production',
    description: 'Complete photo and video production'
  },
  {
    src: '/images/3.webp',
    alt: 'Creative Photography',
    description: 'Creative photography and videography'
  },
  {
    src: '/images/4.webp',
    alt: 'Professional Services',
    description: 'Professional photography and videography'
  }
];

export const prePostWeddingImages = [
  {
    src: '/images/1.webp',
    alt: 'Pre Wedding Photography',
    description: 'Beautiful pre-wedding photography session'
  },
  {
    src: '/images/2.webp',
    alt: 'Post Wedding Photography',
    description: 'Elegant post-wedding photography'
  },
  {
    src: '/images/3.webp',
    alt: 'Wedding Photography',
    description: 'Complete wedding photography coverage'
  },
  {
    src: '/images/4.webp',
    alt: 'Wedding Moments',
    description: 'Capturing precious wedding moments'
  }
];

export const fashionShootImages = [
  {
    src: '/images/1.webp',
    alt: 'Fashion Photography',
    description: 'Professional fashion photography'
  },
  {
    src: '/images/2.webp',
    alt: 'Fashion Shoot',
    description: 'Creative fashion shoot session'
  },
  {
    src: '/images/3.webp',
    alt: 'Style Photography',
    description: 'Elegant style photography'
  },
  {
    src: '/images/4.webp',
    alt: 'Fashion Portfolio',
    description: 'Stunning fashion portfolio'
  }
];

export const corporateEventsImages = [
  {
    src: '/images/1.webp',
    alt: 'Corporate Event Photography',
    description: 'Professional corporate event coverage'
  },
  {
    src: '/images/2.webp',
    alt: 'Business Events',
    description: 'Corporate business events'
  },
  {
    src: '/images/3.webp',
    alt: 'Conference Photography',
    description: 'Conference and meeting photography'
  },
  {
    src: '/images/4.webp',
    alt: 'Corporate Functions',
    description: 'Corporate function photography'
  }
];

export const babyShootsImages = [
  {
    src: '/images/1.webp',
    alt: 'Baby Photography',
    description: 'Adorable baby photography session'
  },
  {
    src: '/images/2.webp',
    alt: 'Newborn Photography',
    description: 'Precious newborn moments'
  },
  {
    src: '/images/3.webp',
    alt: 'Baby Portraits',
    description: 'Beautiful baby portraits'
  },
  {
    src: '/images/4.webp',
    alt: 'Family Baby Photos',
    description: 'Family with baby photography'
  }
];

export const adsImages = [
  {
    src: '/images/1.webp',
    alt: 'Advertising Photography',
    description: 'Creative advertising photography'
  },
  {
    src: '/images/2.webp',
    alt: 'Product Photography',
    description: 'Professional product photography'
  },
  {
    src: '/images/3.webp',
    alt: 'Commercial Photography',
    description: 'Commercial photography services'
  },
  {
    src: '/images/4.webp',
    alt: 'Brand Photography',
    description: 'Brand and marketing photography'
  }
];

export const podcastImages = [
  {
    src: '/images/1.webp',
    alt: 'Podcast Recording',
    description: 'Professional podcast recording'
  },
  {
    src: '/images/2.webp',
    alt: 'Audio Production',
    description: 'High-quality audio production'
  },
  {
    src: '/images/3.webp',
    alt: 'Podcast Studio',
    description: 'Professional podcast studio setup'
  },
  {
    src: '/images/4.webp',
    alt: 'Podcast Production',
    description: 'Complete podcast production services'
  }
];

export const filmMakingImages = [
  {
    src: '/images/1.webp',
    alt: 'Film Making',
    description: 'Professional film making services'
  },
  {
    src: '/images/2.webp',
    alt: 'Video Production',
    description: 'Complete video production'
  },
  {
    src: '/images/3.webp',
    alt: 'Cinematic Production',
    description: 'Cinematic film production'
  },
  {
    src: '/images/4.webp',
    alt: 'Film Production',
    description: 'Professional film production'
  }
];
